import { render, staticRenderFns } from "./search_seed_introduce.vue?vue&type=template&id=172ff5b3&"
import script from "./search_seed_introduce.vue?vue&type=script&lang=js&"
export * from "./search_seed_introduce.vue?vue&type=script&lang=js&"
import style0 from "./search_seed_introduce.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports